// extracted by mini-css-extract-plugin
export default {"actions":"ConfirmModalContent_actions__q+2sq","normalButton":"ConfirmModalContent_normalButton__Huoar","ConfirmBtn":"ConfirmModalContent_ConfirmBtn__sDbtO"};